// import React from 'react';
// import Translate from 'components/translate';
// import {AppSettings} from '../constants';
// import ManagePunchLists from './Containers/manage-punch-list';
// import AddPunchList from './Containers/add-punch-list';
// import ManagePunchListItems from './Containers/manage-punch-list-items';
// import AddPunchListItem from './Containers/add-punch-list-item';
// import PunchListItemDetail from './Containers/punch-list-item-detail';
// import PublicManagePunchListItems from './Containers/public-manage-punch-list-items';
// import AddPurchaseOrder from './Containers/add-purchase-order';
// import PurchasesOrderDetail from './Containers/purchase-order-detail';
// import AddBackCharge from './Containers/add-back-charge';
// import BackChargeDetail from './Containers/back-charge-detail';
// import EPLForm from './Containers/epl-form';

// export default [
//   {
//     path: '/punch-lists',
//     component: ManagePunchLists,
//     private: true,
//     portal: ['Subcontractor', 'Builder'],
//     menu: {
//       name: AppSettings.clientTypeValue === 'Builder' ? 'Blue Tape' : 'Punch lists',
//       order: 6,
//       icons: 'icon-punch-lists-ic'
//     }
//   },
//   {
//     path: '/punch-lists/:punchListRefNo',
//     component: ManagePunchListItems,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path: '/punch-lists/add',
//     component: AddPunchList,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path: '/public/punch-lists/:punchListRefNo',
//     component: PublicManagePunchListItems,
//     private: false,
//     portal: ['Subcontractor']
//   },
//   {
//     path: '/punch-lists/:punchListRefNo/add',
//     component: AddPunchListItem,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path: '/punch-lists/:punchListRefNo/punch-list-item/:punchListItemRefNo',
//     component: PunchListItemDetail,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path: '/punch-lists/electronic-punch-list/:RFSID',
//     component: EPLForm,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path: '/punch-lists/punch-list-item/purchase-order/:RFSID/:WOID/add',
//     component: AddPurchaseOrder,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path:
//       '/punch-lists/punch-list-item/purchase-order/:RFSID/:WOID/detail/:POID',
//     component: PurchasesOrderDetail,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path: '/punch-lists/punch-list-item/back-charge/:RFSID/:WOID/:POID/add',
//     component: AddBackCharge,
//     private: true,
//     portal: ['Builder']
//   },
//   {
//     path:
//       '/punch-lists/punch-list-item/back-charge/:RFSID/:WOID/:POID/detail/:BCID',
//     component: BackChargeDetail,
//     private: true,
//     portal: ['Builder']
//   }
// ];
import React from 'react';
import Translate from 'components/translate';
import {AppSettings} from '../constants';
import ManagePunchLists from './Containers/manage-punch-list';
import AddPunchList from './Containers/add-punch-list';
import ManagePunchListItems from './Containers/manage-punch-list-items';
import AddPunchListItem from './Containers/add-punch-list-item';
import PunchListItemDetail from './Containers/punch-list-item-detail';
import PublicManagePunchListItems from './Containers/public-manage-punch-list-items';
import AddPurchaseOrder from './Containers/add-purchase-order';
import PurchasesOrderDetail from './Containers/purchase-order-detail';
import AddBackCharge from './Containers/add-back-charge';
import BackChargeDetail from './Containers/back-charge-detail';
import EPLForm from './Containers/epl-form';

export default [
  {
    path: '/punch-lists',
    component: ManagePunchLists,
    private: true,
    portal: ['Subcontractor', 'Builder'],
    menu: {
      name: AppSettings.clientTypeValue === 'Builder' ? 'Blue Tape' : 'Punch lists',
      order: 6,
      icons: 'icon-punch-lists-ic'
    }
  },
  {
    path: '/punch-lists/add',
    component: AddPunchList,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/punch-lists/:punchListRefNo',
    component: ManagePunchListItems,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/public/punch-lists/:punchListRefNo',
    component: PublicManagePunchListItems,
    private: false,
    portal: ['Subcontractor']
  },
  {
    path: '/punch-lists/:punchListRefNo/add',
    component: AddPunchListItem,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/punch-lists/:punchListRefNo/punch-list-item/:punchListItemRefNo',
    component: PunchListItemDetail,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/punch-lists/electronic-punch-list/:RFSID',
    component: EPLForm,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/punch-lists/punch-list-item/purchase-order/:RFSID/:WOID/add',
    component: AddPurchaseOrder,
    private: true,
    portal: ['Builder']
  },
  {
    path:
      '/punch-lists/punch-list-item/purchase-order/:RFSID/:WOID/detail/:POID',
    component: PurchasesOrderDetail,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/punch-lists/punch-list-item/back-charge/:RFSID/:WOID/:POID/add',
    component: AddBackCharge,
    private: true,
    portal: ['Builder']
  },
  {
    path:
      '/punch-lists/punch-list-item/back-charge/:RFSID/:WOID/:POID/detail/:BCID',
    component: BackChargeDetail,
    private: true,
    portal: ['Builder']
  }
];



// WEBPACK FOOTER //
// ./src/Punch-List/routes.js